import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import api from '@/api';

const ManageBillListPage = () => {
  const { current: company } = useSelector((state: RootState) => state.company);

  useEffect(() => {
    if (company) {
      api.get('/solution/history/daily', { params: { companyId: company?.base?.id, solutionId: 1 } }).then(({ data }) => {
        console.log(data);
      });
    }
  }, [company]);

  return (
    <div className="p-5">
      <h1 className="text-2xl font-bold mb-5">서비스 청구 내역</h1>

      {company === null && <div>회사 가입 승인 후 사용 가능합니다.</div>}
    </div>
  );
};

export default ManageBillListPage;
